// extracted by mini-css-extract-plugin
export default {"container":"_8818_","slide":"_23Ffe","postWrapper":"_2CVNe","separator":"_3gHuA"};